(function(window, $) {
    'use strict';

    function DataLayerTrigger() {
    }

    DataLayerTrigger.traceException = function(e) {
        e = new Error("["+(new Date().toString())+"] Error in DataLayerTrigger.js : "+e);
        if (typeof e.stack != "undefined") {
            e.message += "\r\nstack : "+e.stack;
        }
        var additionalData = [];
        var argumentValueBackup;
        for (var i = 1;i < arguments.length;i++) {
            if (typeof arguments[i] == 'object') {
                try {
                    argumentValueBackup = arguments[i];
                    arguments[i] = JSON.stringify(arguments[i]);
                } catch (e) {
                    arguments[i] = argumentValueBackup;
                }
            }
            additionalData.push(arguments[i]);
        }
        e.message += "\r\nData : \r\n"+additionalData.join("\r\n\r\n");
        console.error(additionalData);
    };

    DataLayerTrigger.login = function (method, action = '', userId = '') {
        try {
            var dataLayer = window.dataLayer || [];
            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "" && typeof method == 'string') {
                pushToWshopBus({
                    'event': 'login',
                    'user_id': userId,
                    'method': method,
                    'login_location': (action == 'identification.php') ? 'Checkout' : 'header'
                });

                window.pushToWshopBus({
                    'event': 'registrationComplete',
                    'type': 'customer',
                    'channel': 'natural'
                });

                DataLayerTrigger.pushSocialConnect(method);
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.signup = function(method, general , sms) {
        try {
            var offer = [];
            var str = '';
            var newsletter_optin = false;
            var dataLayer = window.dataLayer || [];
            if (general) {
                offer.push('email');
                newsletter_optin = true;
            }
            if (sms) {
                offer.push('sms');
            }

            if (offer.length == 0) {
                str = 'none';
            } else if (offer.length > 0) {
                str = offer.toString();
            }
            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "" && typeof method == 'string') {
                pushToWshopBus({
                    'event': 'sign_up',
                    'method': method,
                    'sign_up_bestOffers': str,
                    'newsletter_optin': newsletter_optin,
                    'newsletter_subscription_date': newsletter_optin ? getJsformatDateYMD() : '',
                    'newsletter_subscription_source' : 'Account'
                });

                window.pushToWshopBus({
                    'event': 'registrationComplete',
                    'type': 'customer',
                    'channel': 'natural',
                });

                DataLayerTrigger.pushSocialConnect(method);

            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.search = function(search_term, search_results, from_algolia = false) {
        try {

            var dataLayer = window.dataLayer || [];
            var results_number = from_algolia ? search_results : (Array.isArray(search_results) ? search_results.length : 0);
            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    'event': 'search',
                    'search_term': search_term,
                    'search_results': results_number,
                });
            }

            this.searchAction(search_results);

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.searchAction = function(search_results) {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "view_item_list",
                    ecommerce: {
                        item_list_name: 'Search Result',
                        items: search_results
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.addPaymentInfo = function(impressions, actionField, type, amount = 0) {

        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {
            var impressions = JSON.parse(impressions);
            var actionField = JSON.parse(actionField);

            try {

                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "add_payment_info",
                        ecommerce: {
                            currency: actionField['currency'],
                            value: type == 'GiftCard' ? parseFloat(amount) : parseFloat(actionField['value']),
                            coupon: actionField['coupon'],
                            payment_type: type,
                            items: impressions
                        }
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }
    };

    DataLayerTrigger.giftCardPayment = function(amount) {
        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "giftCard",
                    amount: amount
                });
            }

        } catch (e) {
            console.error(e);
        }
    };
    let addedShippingInfo = false;
    DataLayerTrigger.addShippingInfo = function(impressions, actionField, shipping_tier, free_delivery = false) {
        // Ensure event is triggered only once
        if (addedShippingInfo) {
            return;
        }
        addedShippingInfo = true;
        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {
            var impressions = JSON.parse(impressions);
            var actionField = JSON.parse(actionField);

            try {
                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "add_shipping_info",
                        ecommerce: {
                            currency: actionField.currency,
                            value: parseFloat(actionField.revenue),
                            coupon: actionField.coupon,
                            shipping_tier: shipping_tier,
                            free_delivery: free_delivery,
                            items: impressions
                        }
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }
    };

    DataLayerTrigger.addDeliveryTypesSeen = function(listOfDeliveries) {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "delivery_type_seen",
                    delivery_type_seen : listOfDeliveries
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    let deliveryClickCalled = false;
    DataLayerTrigger.addDeliverTypeClick = function(listOfDeliveries, freeDelivery) {
        // Ensure event is triggered only once
        if (deliveryClickCalled) {
            return;
        }

        deliveryClickCalled = true;

        try {
            var dataLayer = window.dataLayer || [];

            document.cookie = "wshop_shipping_tier=" + encodeURIComponent(listOfDeliveries) + ";path=/;SameSite=Lax";

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "delivery_type_click",
                    delivery_type_seen : listOfDeliveries,
                    free_delivery: freeDelivery ?? false,

                });
            }
        } catch (e) {
            console.error(e);
        }
    };
    DataLayerTrigger.rdvStore = function() {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "rdvInStore_click",
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.findStore = function() {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "find_storeLocator_click",
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.storeLocator = function(name, country, city) {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: 'storeLocator',
                    storeLocator_name: name,
                    storeLocator_detail: '',
                    storeLocator_country: country,
                    storeLocator_town: city,
                });
            }

        } catch (e) {
            console.error(e);
        }
    };


    DataLayerTrigger.stockAlert = function(id, category) {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: 'alert_outOfStock',
                    product_id: name,
                    product_category: category,
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.faqClick = function(path, item) {
        // check step item
        if ($("body").hasClass("step_1")) {
            path = " funnel step 1"
        }else if ($("body").hasClass("step_2")) {
            path = " funnel step 2"
        }
        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: 'faq_click',
                    faq_path: path,
                    faq_name: item,

                });
            }

        } catch (e) {
            console.error(e);
        }
    };
    DataLayerTrigger.alertStock = function() {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: 'stock_alert'
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.addToCart = function(impressions, actionField, is_achat_express = false) {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "add_to_cart",
                    cart_id: actionField['cart_id'],
                    event_location: DataLayerTrigger.getCurrentPageType(),
                    ecommerce: {
                        currency: actionField['currency'],
                        value: parseFloat(actionField['revenue']),
                        items: [impressions],
                        is_achat_express: is_achat_express,
                        event_id:  actionField['event_id']
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    };
    DataLayerTrigger.addToWishList = function(impressions, actionField) {
        try {

            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "add_to_wishlist",
                    event_location: DataLayerTrigger.getCurrentPageType(),
                    ecommerce: {
                        currency: actionField['currency'],
                        value: parseFloat(actionField['value']),
                        items: [impressions]
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.cart_product_action = function(impressions, actionField, prodId, action, value = 0) {

        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {
            var impressions = JSON.parse(impressions);

            var actionField = JSON.parse(actionField);

            var selectedItem = [];
            // determine item removed from cart

            for (var impression in impressions) {

                if (impressions[impression]['wshop_product_id'] == prodId) {
                    selectedItem.push(impressions[impression]);
                }
            }
            if ( value != null && value != 0 && value != undefined) {
                selectedItem[0]['quantity'] = Math.abs(value);
            }
            try {

                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "" && selectedItem.length > 0) {
                    var payload = {
                        event: action,
                        cart_id: actionField['cart_id'],
                        ecommerce: {
                            currency: actionField['currency'],
                            value: parseFloat(selectedItem[0]['price']),
                            items: selectedItem
                        }
                    };
                    // Add event_location only if the action is add_to_cart
                    if (action === 'add_to_cart') {
                        payload.event_location = DataLayerTrigger.getCurrentPageType();
                    }
                    pushToWshopBus(payload);
                }

            } catch (e) {
                console.error(e);
            }
        }
    };


    DataLayerTrigger.wishlist_cart_product_action = function(impressions, actionField, prodId, action, value = 0) {

        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {
            var impressions = JSON.parse(impressions);
            var actionField = JSON.parse(actionField);

            var selectedItem = [];

            // determine item removed from cart
            for (var i = 0; i < impressions.length; i++) {
                if (impressions[i]['wshop_product_id'] == prodId || impressions[i]['wishlist_product_id'] === prodId) {
                    selectedItem.push(impressions[i]);
                }
            }
            if ( value != null && value != 0 && value != undefined) {
                selectedItem[0]['quantity'] = Math.abs(value);
            }

            try {

                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "" && selectedItem) {

                    var payload = {
                        event: action,
                        ecommerce: {
                            currency: actionField['currency'],
                            value: selectedItem[0]['price'],
                            items: selectedItem
                        }
                    };

                    if (action === 'add_to_cart') {
                        payload.event_location = DataLayerTrigger.getCurrentPageType();
                    }

                    pushToWshopBus(payload);
                }

            } catch (e) {
                console.error(e);
            }
        }
    };
    DataLayerTrigger.wishlist_cart_multiple_product_action = function(impressions, actionField, products, action) {

        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {
            var impressions = JSON.parse(impressions);
            var  actionField = JSON.parse(actionField);

            var selectedItems = [];


            for (var i = 0; i < impressions.length; i++) {

                for (var j = 0; j < products.length; j++) {
                    if (impressions[i]['wishlist_product_id'] == products[j]) {
                        selectedItems.push(impressions[i]);
                    }
                }

            }


            try {

                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    var payload = {
                        event: action,
                        ecommerce: {
                            currency: actionField['currency'],
                            value: parseFloat(actionField['revenue']),
                            items: selectedItems
                        }
                    };

                    if (action === 'add_to_cart') {
                        payload.event_location = DataLayerTrigger.getCurrentPageType();
                    }

                    pushToWshopBus(payload);
                }
            } catch (e) {
                console.error(e);
            }
        }
    };

    DataLayerTrigger.selectItem = function(impressions, actionField, prodId) {

        if (typeof impressions !== 'undefined' && typeof actionField !== 'undefined') {

            var impressions = JSON.parse(impressions);
            var actionField = JSON.parse(actionField);

            var selectedItems = [];

            for (var i = 0; i < impressions.length; i++) {
                if (impressions[i]['item_id'] == prodId || impressions[i]['wishlist_product_id'] == prodId ) {
                    selectedItems.push(impressions[i]);
                    break;
                }

            }
            try {
                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "select_item",
                        event_location: DataLayerTrigger.getCurrentPageType(), // Added here
                        ecommerce: {
                            item_list_name:  actionField['item_list_name'],
                            items: selectedItems
                        }
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }
    };


    DataLayerTrigger.beginCheckout = function() {

        if (typeof dl_v3_impressions !== 'undefined' && typeof dlv3_action_fields !== 'undefined') {

            var impressions = JSON.parse(dl_v3_impressions);
            var actionField = JSON.parse(dlv3_action_fields);

            try {
                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "begin_checkout",
                        ecommerce: {
                            currency: actionField['currency'],
                            value: parseFloat(actionField['value']),
                            coupon: actionField['coupon'],
                            items: impressions
                        }
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }
    };


    let checkoutStepAdded = false;
    DataLayerTrigger.checkoutStep = function(impressions, actionField, checkout_step_name, checkout_step_number) {
        if (checkoutStepAdded) {
            return;
        }
        checkoutStepAdded = true;

        if (typeof dl_v3_impressions !== 'undefined' && typeof dlv3_action_fields !== 'undefined') {
            var impressions = JSON.parse(dl_v3_impressions);
            var actionField = JSON.parse(dlv3_action_fields);

            try {
                var dataLayer = window.dataLayer || [];

                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "checkout",
                        checkout_step_name: checkout_step_name,
                        checkout_step_number: checkout_step_number,
                        cart_id: actionField['cart_id'],
                        ecommerce: {
                            currency: actionField['currency'],
                            value: parseFloat(actionField['value']),
                            coupon: actionField['coupon'],
                            items: impressions
                        }
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }
    };

    DataLayerTrigger.socialClick = function(social) {


        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "social_click",
                    event_label: social
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.filerInteraction = function(params) {

        // let's split params to get infos
        if (params) {

            var  orderList = {
                'desc': 'decroissant',
                'asc': 'croissant',
                'new': 'nouveaute'
            }
            var filters_applied = '';
            var filters_numbers_applied = '';
            var filters_sorting_applied = '';
            var list = params.split("?");
            var list = list[1]; // remove empty element after '?'

            var newList = list.split("&");

            if (newList.length > 0) {
                var nbrs = newList.length
                filters_numbers_applied = nbrs;
                for (var i = 0; i < nbrs; i++) {
                    if (newList[i].includes('order=')){
                        var order = newList[i].split('=');
                        filters_sorting_applied = orderList[order[1]];
                    } else {
                        var filterApplied = newList[i].replace('=', '_');

                        filters_applied = filters_applied + filterApplied + ' | ';
                    }
                }
            }

            try {
                var dataLayer = window.dataLayer || [];
                var filters = filters_applied.slice(0, -1);
                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "filter_interaction",
                        filters_applied: filters,
                        filters_numbers_applied: filters_numbers_applied,
                        filters_sorting_applied: filters_sorting_applied,
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }


    };



    DataLayerTrigger.filerInteractionSearch = function(params) {

        // let's split params to get infos
        if (params) {

            var  orderList = {
                '-1': 'prix decroissant',
                '1': 'prix croissant',
                '2': 'nouveautes'
            }
            var filters_applied = '';
            var filters_numbers_applied = '';
            var filters_sorting_applied = '';
            var list = params.split("&");
            list.shift();

            var nbrs = list.length
            if (nbrs > 0) {
                filters_numbers_applied = nbrs;
                for (var i = 0; i < nbrs; i++) {
                    if (list[i].includes('tri=')){
                        var order = list[i].split('=');
                        filters_sorting_applied = orderList[order[1]];
                    } else {
                        var filterApplied = list[i].replace('=', '_');

                        filters_applied = filters_applied + filterApplied + ' | ';

                    }


                }
            }

            try {
                var dataLayer = window.dataLayer || [];
                var filters = filters_applied.slice(0, -1);
                if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                    pushToWshopBus({
                        event: "filter_interaction",
                        filters_applied: filters,
                        filters_numbers_applied: filters_numbers_applied,
                        filters_sorting_applied: filters_sorting_applied,
                    });
                }

            } catch (e) {
                console.error(e);
            }
        }


    };

    DataLayerTrigger.filerInteractionSearchMobile = function(params) {
        var dataParams = ['couleur', 'taille', 'tri','theme', 'category_id','subcateg_id', 'object_id', 'eclat', 'charact'];
        var  orderList = {
            '2': 'prix decroissant',
            '1': 'prix croissant',
            '5': 'nouveautes'
        }

        var selectedParams = [];

        for (var i = 0; i < dataParams.length; i++) {
            if (params[dataParams[i]] != '0' && params[dataParams[i]] != undefined ) { // only splice array when item is found
                selectedParams.push(dataParams[i]); // 2nd parameter means remove one item only
            }
        }



        var filters_applied = '';
        var filters_numbers_applied = '';
        var filters_sorting_applied = '';


        var nbrs = selectedParams.length
        if (nbrs > 0) {
            filters_numbers_applied = nbrs;
            for (var i = 0; i < nbrs; i++) {
                if (selectedParams[i] == 'tri'){
                    filters_sorting_applied = orderList[params[selectedParams[i]]];
                } else {
                    var filterApplied = selectedParams[i] + '_' + params[selectedParams[i]];
                    filters_applied = filters_applied + filterApplied + ' | ';
                }

            }
        }

        try {
            var dataLayer = window.dataLayer || [];
            var filters = filters_applied.slice(0, -1);
            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "filter_interaction",
                    filters_applied: filters,
                    filters_numbers_applied: filters_numbers_applied,
                    filters_sorting_applied: filters_sorting_applied,
                });
            }

        } catch (e) {
            console.error(e);
        }

    };

    DataLayerTrigger.viewItem = function(data) {
        try {

            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "view_item",
                    ecommerce: {
                        items: [data['items']]
                    }
                });
            }

        } catch (e) {
            console.error(e);
        }
    };


    DataLayerTrigger.CheckAvailability = function(id, category, step, stepName) {

        try {

            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "product_checkAvailability",
                    product_id: id,
                    product_category: category,
                    step_index: step,
                    step_name: stepName
                });
            }

        } catch (e) {
            console.error(e);
        }
    }


    DataLayerTrigger.productDetailClick = function(id, category, label) {

        try {

            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "product_detail_click",
                    detail_label: label,
                    product_id: id,
                    product_category: category
                });
            }

        } catch (e) {
            console.error(e);
        }
    }


    DataLayerTrigger.CustomCabas = function(index, name, action, label) {

        try {

            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: "cabas_custom",
                    step_index: index,
                    step_name: name,
                    event_action: action,
                    event_label: label
                });
            }

        } catch (e) {
            console.error(e);
        }
    }

    DataLayerTrigger.newsSubmit = async function (news = '', mail = '', sms = '', fidelity = '', location = '', email = '', optin = true) {
        try {
            var offer = [];
            var str = '';
            var dataLayer = window.dataLayer || [];

            if (news) {
                offer.push('newsletter');
            }
            if (mail) {
                offer.push('bestOffers mail');
            }
            if (sms) {
                offer.push('bestOffers sms');
            }
            if (fidelity) {
                offer.push('fidelity');
            }

            if (offer.length == 0) {
                str = 'none';
            } else if (offer.length > 0) {
                str = offer.join('|');
            }
            let email_sha256 = '';
            if (email) {
                email_sha256 = await emailToSha256Hex(email);
            }
            const isOptin = optin === true;
            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    'event': 'newsletter_submit',
                    'email_sha256': email_sha256,
                    'form_name': str,
                    'form_location': location,
                    'newsletter_optin': isOptin,
                    'newsletter_subscription_source': location,
                    'newsletter_subscription_date': getJsformatDateYMD()
                });
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.storeLocator = function(name, country, city) {

        try {
            var dataLayer = window.dataLayer || [];

            if (dataLayer !== undefined && dataLayer !== null && dataLayer !== "") {
                pushToWshopBus({
                    event: 'storeLocator',
                    storeLocator_name: name,
                    storeLocator_detail: '',
                    storeLocator_country: country,
                    storeLocator_town: city,
                });F
            }

        } catch (e) {
            console.error(e);
        }
    };

    DataLayerTrigger.trackStoreAvailability = function() {
        try {
            var dataLayer = window.dataLayer || [];

            var item = null;

            // Search backwards to find the latest product data
            for (var i = dataLayer.length - 1; i >= 0; i--) {
                var entry = dataLayer[i];

                if (entry.event === 'view_item' && entry.ecommerce) {
                    var items = entry.ecommerce.items;

                    // Handle both items: [{...}] and the accidental items: [[{...}]]
                    if (Array.isArray(items)) {
                        item = Array.isArray(items[0]) ? items[0][0] : items[0];
                    }
                }
            }

            if (item && item.item_id) {
                window.pushToWshopBus({
                    'event': 'store_availability',
                    'ecommerce': {
                        'currency': item.currency || 'EUR',
                        'value': parseFloat(item.price || 0),
                        'items': [item]
                    }
                });
            }
        } catch (e) {
            this.traceException(e, "trackStoreAvailability");
        }
    };

    DataLayerTrigger.pushSocialConnect = function(method) {
        // special social_connect event for GA4 use (active/deactivate)
        const socialMethods = {
            google: true,
            paypal: true,
            amazon: true,
            facebook: true
        };

        if (socialMethods[method]) {
            pushToWshopBus({
                event: 'social_connect',
                type: `connect_with_${method}`
            });
        }
    };

    DataLayerTrigger.getCurrentPageType = function() {
        var type = 'other';
        try {
            var dataLayer = window.dataLayer || [];
            // Look for the page_context object (usually at index 1 as per your screenshot)
            for (var i = 0; i < dataLayer.length; i++) {

                if (dataLayer[i] && dataLayer[i].page_type) {
                    type = dataLayer[i].page_type;
                    break;
                }
            }
        } catch (e) {
            console.error("Error retrieving page_type", e);
        }
        return type;
    };

    window.DataLayerTrigger = DataLayerTrigger;

})(window, $);


async function emailToSha256Hex(email) {
    const normalized = String(email).trim().toLowerCase();
    const data = new TextEncoder().encode(normalized);

    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Returns the current date formatted as YYYY-MM-DD.
 *
 * @returns {string} A string representing today's date in the format "YYYY-MM-DD".
 *
 * @example
 * const today = formatDateYMD(); // "2025-07-22"
 */
function getJsformatDateYMD() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}